import { read } from "@/api/rest";

const projectTaskRole = {
  index: async (params) => await read('/project-task-role', {params}),
  view: async (id) => await read(`/project-task-role/${id}`),
};

export default projectTaskRole;